import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Container, Form, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Badge, Button, Dropdown, Table } from "react-bootstrap";
import { DateRangePicker } from "react-date-range";
import moment from "moment";
import moments from "moment-timezone"
import { toast } from "react-toastify";
import WhatsAppAPI from "../../../api/schoolApi";
import Confirm from "../../Confirm";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const Templateview = ({ selectedWhatsAppSetting }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [templateData, setTemplateData] = useState(location.state ? location.state : {});

// Unix timestamp ko readable date format me convert karne ke liye:

  const [body, setBody] = useState([]);
  const [isSpinner, setIsSpinner] = useState(false);
   const [templateDelete, setTemplateDelete] = useState(false);
       const [rowData, setRowData] = useState();
       const [formattedData,setFormattedData] =useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileURL, setSelectedFileURL] = useState(null);
  const [selectedFileType, setSelectedFileType] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const docxIcon = "/user_images/doc-icon.png";
  const fileInputRef = useRef(null);

  const [dateRange, setDateRange] = useState([]);
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef(null);

  // Recipient Tracking states
  const [recipients, setRecipients] = useState([]);
  const [loadingRecipients, setLoadingRecipients] = useState(false);
  const [activeStatusFilter, setActiveStatusFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;
  const recipientsTableRef = useRef(null);
  console.log("templateData->", templateData);
  useEffect(() => {
    //setParameters({});

    if (templateData && typeof tamplateparms === "object") {
      const { sendToAdmin, file, file_id, whatsapp_number_admin, ...restParameters } = templateData;
      if (file) {
        setSelectedFile(file);
        setSelectedFileType(file.type);
        setSelectedFileURL(URL.createObjectURL(file));
      }

    }

  }, [templateData]);
  const renderFormattedMessage = () => {
    let formattedText = templateData?.message_body || "";
    //Object.keys(parameters).forEach((key) => {
    //  const placeholder = `{{${key}}}`;
    //  const replacement = parameters[key] || placeholder;
    //  formattedText = formattedText.replace(new RegExp(placeholder, "g"), replacement);
    //});
    formattedText = formattedText.replace(/(\n)+/g, "<br />");
    formattedText = formattedText.replace(/\*(.*?)\*/g, "<strong>$1</strong>");
    return <span dangerouslySetInnerHTML={{ __html: formattedText }} />;
  };
  const getHeader = () => {
    if (selectedFileURL) {
      if (selectedFileType && selectedFileType.includes("image")) {
        return <img src={selectedFileURL} alt="Uploaded Preview" className="img-fluid rounded w-100 mb-2" style={{ height: "200px", objectFit: "cover" }} />;
      } else if (selectedFileType && selectedFileType.includes("video")) {
        return <video src={selectedFileURL} controls className="img-fluid rounded w-100 mb-2" style={{ height: "200px", objectFit: "cover" }} />;
      } else if (selectedFileType) {
        return <a href={selectedFileURL} target="_blank" rel="noopener noreferrer">
          <img src={docxIcon} alt="Document Thumbnail" className="img-fluid rounded w-100 mb-2" style={{ height: "200px", objectFit: "cover" }} />
        </a>;
      }
    }

    if (templateData?.header) {
      //console.log("hear pankaj");

      switch (templateData.header) {
        case "IMAGE":
          return <img src={templateData.header_image_url} alt="Template Header" className="img-fluid rounded w-100 mb-2" style={{ height: "200px", objectFit: "cover" }} />;
        case "VIDEO":
          return <video src={templateData.header_video_url} controls className="img-fluid rounded w-100 mb-2" style={{ height: "200px", objectFit: "cover" }} />;
        case "DOCUMENT":
          return <a href={templateData.header_document_url} target="_blank" rel="noopener noreferrer">
            <img src={docxIcon} alt="Document Thumbnail" className="img-fluid rounded w-100 mb-2" style={{ height: "200px", objectFit: "cover" }} />
          </a>;
        default:
          return <strong>{templateData.header_text}</strong>;
      }
    }

    return null;
  };

  const getFooter = () => (templateData.footer ? <div className="template-footer text-muted">{templateData.footer}</div> : null);

  const getButtons = () => {
    if (templateData.buttons && templateData.buttons.length > 0) {
      const quickReplyButtons = templateData.buttons.filter((button) => button.type === "QUICK_REPLY");
      const otherButtons = templateData.buttons.filter((button) => button.type !== "QUICK_REPLY");

      return (
        <div className="template-buttons mt-3">
          {otherButtons.map((button, index) => (
            <div key={index} className="btn btn-outline-secondary btn-sm mb-2">
              {button.text}
            </div>
          ))}
          {quickReplyButtons.length > 1 && (
            <div className="btn btn-outline-secondary btn-sm mb-2">See More Options</div>
          )}
        </div>
      );
    }
    return null;
  };
  const handleBack = () => {
    navigate("/Templates");
  }
  const closeCalendar = () => {
    setShowCalendar(false);
  }
  const removeSelectedRow = (data) => {
    setTemplateDelete(true);

    setRowData(data?.templateData);
}
const deleteTemplate = async () => {
    if (rowData.id && rowData.name) {
        const result = await WhatsAppAPI.deleteTemplateRecord(rowData.id, rowData.name,selectedWhatsAppSetting);
        if (result.success) {
            setTemplateDelete(false);
            //toast.success('Template deleted successfully.');
            navigate("/Templates");
            //setTimeout(() => {
            //}, 2000);
            //fetchAllTemplates(selectedWhatsAppSetting);
        } else {
            setTemplateDelete(false);
            //toast.error(result.error.message);
        }
    }
}

  const handleSelect = (ranges) => {
    console.log("ranges->",ranges);
    
    setDateRange([ranges.selection]);
  };

  const selectDate = () => {
    setShowCalendar(false);
    let firstdate = moments(dateRange[0]?.startDate).tz("Asia/Kolkata").startOf('day').unix();
    let lastdate = moments(dateRange[0]?.endDate).tz("Asia/Kolkata").endOf('day').unix();
    init(firstdate, lastdate);
  }
//  useEffect(() => {
//    setDateRange([
//      {
//        startDate: moment().startOf('month').format(),
//        endDate: moment().endOf('month').format(),
//        key: 'selection'
//      }
//    ]);
//
//    let firstdate = moment().tz("Asia/Kolkata").startOf('month').unix();
//    let lastdate = moment().tz("Asia/Kolkata").endOf('month').unix();
//
//
//
//    init(firstdate, lastdate);
//    setIsSpinner(false);
//
//  }, [selectedWhatsAppSetting]);
//useEffect(() => {
//  const currentTime = moment().tz("Asia/Kolkata").unix(); // Current timestamp
//  const ninetyDaysAgo = currentTime - (90 * 24 * 60 * 60); // 90 days ago
//
//  let firstdate = Math.max(moment().tz("Asia/Kolkata").startOf('month').unix(), ninetyDaysAgo);
//  let lastdate = Math.min(moment().tz("Asia/Kolkata").endOf('month').unix(), currentTime);
//  //let firstdate = moments(dateRange[0]?.startDate).tz("Asia/Kolkata").startOf('day').unix();
//  //let lastdate = moments(dateRange[0]?.endDate).tz("Asia/Kolkata").endOf('day').unix();
//  setDateRange([
//      {
//          startDate: new Date(firstdate),
//          endDate: new Date(lastdate),
//          key: 'selection'
//      }
//  ]);
//  
//  init(firstdate, lastdate);
//  setIsSpinner(false);
//}, []);
useEffect(() => {
  const currentTime = moment().tz("Asia/Kolkata").unix(); // Current timestamp in seconds
  const ninetyDaysAgo = currentTime - 90 * 24 * 60 * 60; // 90 days ago in seconds

  let firstdate = Math.max(moment().tz("Asia/Kolkata").startOf('month').unix(), ninetyDaysAgo);
  let lastdate = Math.min(moment().tz("Asia/Kolkata").endOf('month').unix(), currentTime);
  console.log("firstdate->", firstdate);

  setDateRange([
    {
      startDate: moment.unix(firstdate).toDate(),
      endDate: moment.unix(lastdate).toDate(),
      key: 'selection'
    }
  ]);

  init(firstdate, lastdate);
  setIsSpinner(false);
}, []);

  const fetchRecipients = async (start = '', end = '') => {
    setLoadingRecipients(true);
    try {
      const templateIdentifier = templateData?.id || templateData?.name;
      if (!templateIdentifier) {
        setLoadingRecipients(false);
        return;
      }
      let res = await WhatsAppAPI.getMessageHistoryByTemplate(templateIdentifier, start, end);
      if (res && res.success && res.records && res.records.length > 0) {
        setRecipients(res.records);
      } else if (templateData?.name && templateData.name !== templateIdentifier) {
        res = await WhatsAppAPI.getMessageHistoryByTemplate(templateData.name, start, end);
        if (res && res.success) {
          setRecipients(res.records || []);
        } else {
          setRecipients([]);
        }
      } else {
        setRecipients(res?.records || []);
      }
    } catch (err) {
      console.error("Error fetching recipients:", err);
      setRecipients([]);
    } finally {
      setLoadingRecipients(false);
    }
  };

  const handleUpdateStatus = async (recordId, newStatus) => {
    try {
      const res = await WhatsAppAPI.updateMessageDeliveryStatus(recordId, newStatus);
      if (res && res.success) {
        toast.success(`Marked as ${newStatus}`);
        setRecipients((prev) =>
          prev.map((r) =>
            r.id === recordId
              ? {
                  ...r,
                  delivery_status: newStatus,
                  is_read: newStatus === "read" ? true : r.is_read,
                  received_time: new Date().toISOString()
                }
              : r
          )
        );
      } else {
        toast.error("Failed to update status");
      }
    } catch (e) {
      toast.error("Error updating status");
    }
  };

  const handleStatClick = (status) => {
    setActiveStatusFilter(status);
    setCurrentPage(1);
    if (recipientsTableRef.current) {
      recipientsTableRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  async function init(start = '', end = '') {
    setIsSpinner(false);
    fetchRecipients(start, end);

    const billData = await WhatsAppAPI.getTemplateaAmountBySetting(templateData?.id, start, end);

    if (billData.success) {
      let totalAmountSpent = 0;
      let totalCostPerDelivered = 0;
      let totalSent = 0;
      let totalDelivered = 0;
      let totalRead = 0;
      const formattedData = billData.result.map(item => ({
        date: new Date(item.start * 1000).toLocaleDateString(),
        sent: item.sent || 0,
        delivered: item.delivered || 0,
        read: item.read || 0
      }));
      setFormattedData(formattedData);
      billData.result.forEach(record => {
        totalSent += record.sent || 0;
        totalDelivered += record.delivered || 0;
        totalRead += record.read || 0;

        record.cost.forEach(cost => {
          if (cost.type === 'amount_spent' && cost.value) {
            totalAmountSpent += cost.value;
          }
        });
        const costPerDelivered = record.cost.find(cost => cost.type === 'cost_per_delivered' && cost.value);
        if (costPerDelivered) {
          totalCostPerDelivered = costPerDelivered.value;
        }
      });
      setBody({
        totalSent,
        totalDelivered,
        totalRead,
        totalAmountSpent: totalAmountSpent.toFixed(2),
        totalCostPerDelivered: totalCostPerDelivered.toFixed(2)
      });
      setIsSpinner(true);
    } else {
      setBody([]);
      setIsSpinner(true);
    }
  }

  const editTemplate = (data) => {
    navigate(`/whatsapp_template/add`, { state: data?.templateData });
  };

  const exactReadCount = recipients.filter((r) => r.delivery_status === "read").length;
  const deliveredCount = recipients.filter((r) => r.delivery_status === "delivered").length;
  const sentCount = recipients.filter((r) => r.delivery_status === "sent").length;
  const failedCount = recipients.filter((r) => r.delivery_status === "failed").length;

  const filteredRecipients = recipients.filter((r) => {
    if (activeStatusFilter === "read" && r.delivery_status !== "read") return false;
    if (activeStatusFilter === "delivered" && r.delivery_status !== "delivered") return false;
    if (activeStatusFilter === "sent" && r.delivery_status !== "sent") return false;
    if (activeStatusFilter === "failed" && r.delivery_status !== "failed") return false;

    if (searchQuery.trim() !== "") {
      const q = searchQuery.toLowerCase();
      const matchName = (r.name || "").toLowerCase().includes(q);
      const matchPhone = (r.whatsapp_number || "").includes(q);
      return matchName || matchPhone;
    }
    return true;
  });

  const totalPages = Math.ceil(filteredRecipients.length / recordsPerPage) || 1;
  const paginatedRecipients = filteredRecipients.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const getAvatarColor = (name = "") => {
    const colors = ["#0d6efd", "#198754", "#6f42c1", "#d63384", "#fd7e14", "#20c997", "#0dcaf0"];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  return (
    <>
      <Container className="mt-5">
        <Row className="mx-5 section-header border-bottom pb-3">
          <Col lg={12}>
            <Row className="align-items-center">
              <Col lg={6} sm={12} xs={12} className="mb-2 mb-lg-0">
                <div className="fw-bold">Template</div>
                <h5 className="mt-1">
                  {templateData?.templatename}{' '}
                  <span>• {templateData?.language}</span>
                </h5>
                <span>{templateData?.category}</span>
              </Col>

              <Col lg={6} sm={12} xs={12} className="text-lg-end text-start">
              <Row>
              <Col lg={6} sm={12} xs={12}  className="text-end ">
                  
                  <div className="position-relative">
                    <Form.Group className="d-flex align-items-center">
                      <Form.Control
                        type="text"
                        readOnly
                        className="border p-2 cursor-pointer form-control"
                        value={`${moment(dateRange[0]?.startDate).format("DD/MM/YYYY")} - ${moment(dateRange[0]?.endDate).format("DD/MM/YYYY")}`}
                        onClick={() => setShowCalendar(!showCalendar)}
                      />
                    </Form.Group>

                    {showCalendar && (
                      <div ref={calendarRef} className="calendar-wrapper">
                        <Card bg="light" className="shadow">
                          <Card.Body>
                            <DateRangePicker
                              showSelectionPreview={true}
                              ranges={dateRange}
                              onChange={handleSelect}
                              direction="horizontal"
                              months={2}
                              moveRangeOnFirstSelection={false}
                              maxDate={new Date()} 
                              minDate={new Date(new Date().setDate(new Date().getDate() -88))}
                            />
                          </Card.Body>
                          <Card.Footer className="text-end">
                            <Button className="me-2" onClick={closeCalendar}>
                              Close
                            </Button>
                            <Button onClick={selectDate}>Select Date</Button>
                          </Card.Footer>
                        </Card>
                      </div>
                    )}
                  </div>

                </Col>
                <Col lg={6} sm={12} xs={12}  className="text-start"> 
                <Button className="mx-2 btn-sm" variant="outline-light" onClick={handleBack}>
                  Back
                </Button>
                <Button className="mx-2 btn-sm" variant="light"  onClick={() => editTemplate({ templateData })}>
                  Edit
                </Button>
                <Button className="btn-sm mx-2" variant="danger" onClick={() => removeSelectedRow({ templateData })}>
                  Delete
                </Button>
     
                </Col>
              </Row>
                <Row>
                  
                </Row>

              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {isSpinner ?

      <Container className="mt-5">
        <Row className="mx-5 pb-3">

          <div className="col-md-4">
            <Card className="shadow">
              <Card.Body>
                <Card.Title className="fw-bold mb-3">Your template</Card.Title>
                                <div className="whatsapp-background w-100">
                  <div className="template-box">
                    {getHeader()}
                    <div className="template-content mt-3">
                      {renderFormattedMessage()}
                      {getFooter()}
                      {getButtons()}
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-8">
            <div className="row g-4">
              <div className="col-md-6">
                <Card className="text-center shadow-sm">
                  <Card.Body>
                    <Card.Title className="fw-bold">Amount spent</Card.Title>
                    <p className="display-6 fw-semibold mt-2">₹{body.totalAmountSpent}</p>
                  </Card.Body>
                </Card>
              </div>

              <div className="col-md-6">
                <Card className="text-center shadow-sm">
                  <Card.Body>
                    <Card.Title className="fw-bold">Cost per message delivered</Card.Title>
                    <p className="display-6 fw-semibold mt-2">₹{body.totalCostPerDelivered}</p>
                  </Card.Body>
                </Card>
              </div>
            </div>

            <Card className="mt-4 shadow-sm">
              <Card.Body>
                <Card.Title className="fw-bold mb-3">Performance</Card.Title>
                <div className="row text-center">
                  <div
                    className="col-md-4 py-2 rounded"
                    style={{
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      backgroundColor: activeStatusFilter === "sent" ? "#f0f0f0" : "transparent"
                    }}
                    onClick={() => handleStatClick("sent")}
                    title="Click to view Sent recipients"
                  >
                    <h6 className="text-muted mb-1">Messages sent</h6>
                    <p className="h4 fw-semibold text-danger mb-0">{body?.totalSent}</p>
                    <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                      {sentCount} in records
                    </small>
                  </div>
                  <div
                    className="col-md-4 py-2 rounded"
                    style={{
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      backgroundColor: activeStatusFilter === "delivered" ? "#e6f7ff" : "transparent"
                    }}
                    onClick={() => handleStatClick("delivered")}
                    title="Click to view Delivered recipients"
                  >
                    <h6 className="text-muted mb-1">Messages delivered</h6>
                    <p className="h4 fw-semibold text-primary mb-0">{body?.totalDelivered}</p>
                    <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                      {deliveredCount} in records
                    </small>
                  </div>
                  <div
                    className="col-md-4 py-2 rounded"
                    style={{
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      backgroundColor: activeStatusFilter === "read" ? "#f6ffed" : "transparent",
                      border: activeStatusFilter === "read" ? "1px solid #b7eb8f" : "1px solid transparent"
                    }}
                    onClick={() => handleStatClick("read")}
                    title="Click to view who Read this message"
                  >
                    <h6 className="text-muted mb-1">Messages read</h6>
                    <p className="h4 fw-semibold text-success mb-0">{body?.totalRead}</p>
                    <small className="text-success fw-semibold" style={{ fontSize: "0.75rem" }}>
                      {/* {exactReadCount} in records (View list ↓) */}
                    </small>
                  </div>
                </div>

                <div className="mt-4 bg-light d-flex align-items-center justify-content-center rounded" style={{ height: '200px' }}>
                  {/*<p className="text-muted">Graph Placeholder</p>*/}
                  <ResponsiveContainer width="100%" >
      <LineChart data={formattedData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="sent" stroke="#ff4d4f" name="Messages Sent" />
        <Line type="monotone" dataKey="delivered" stroke="#722ed1" name="Messages Delivered" />
        <Line type="monotone" dataKey="read" stroke="#52c41a" name="Messages Read" />
      </LineChart>
    </ResponsiveContainer>
                </div>
              </Card.Body>
            </Card>
          </div>
        </Row>

        {/* Recipients Tracking Table Section */}
        {/* <Row className="mx-5 pb-5 mt-4" ref={recipientsTableRef}>
          <Col lg={12}>
            <Card className="shadow-sm border-0">
              <Card.Header className="bg-white py-3 border-bottom d-flex flex-wrap justify-content-between align-items-center gap-2">
                <div>
                  <h5 className="mb-0 fw-bold d-flex align-items-center">
                    <i className="fa fa-users text-primary me-2"></i>
                    Recipients & Delivery Status
                    <Badge bg="secondary" className="ms-2 fs-6">
                      {recipients.length} Total
                    </Badge>
                  </h5>
                  <small className="text-muted">
                    Track individual contacts who were sent this template and check if they have read or received it.
                  </small>
                </div>
                <div className="d-flex gap-2">
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => {
                      let firstdate = moments(dateRange[0]?.startDate).tz("Asia/Kolkata").startOf('day').unix();
                      let lastdate = moments(dateRange[0]?.endDate).tz("Asia/Kolkata").endOf('day').unix();
                      fetchRecipients(firstdate, lastdate);
                    }}
                    title="Refresh Recipient List"
                  >
                    <i className={`fa fa-refresh me-1 ${loadingRecipients ? 'fa-spin' : ''}`}></i>
                    Refresh
                  </Button>
                </div>
              </Card.Header>

              <Card.Body className="p-3"> */}
                {/* Status Filter Tabs & Search Bar */}
                {/* <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
                  <div className="btn-group" role="group">
                    <Button
                      variant={activeStatusFilter === "all" ? "primary" : "outline-secondary"}
                      size="sm"
                      onClick={() => { setActiveStatusFilter("all"); setCurrentPage(1); }}
                    >
                      All ({recipients.length})
                    </Button>
                    <Button
                      variant={activeStatusFilter === "read" ? "success" : "outline-success"}
                      size="sm"
                      onClick={() => { setActiveStatusFilter("read"); setCurrentPage(1); }}
                    >
                      <i className="fa fa-check-double me-1"></i>
                      Read ({exactReadCount})
                    </Button>
                    <Button
                      variant={activeStatusFilter === "delivered" ? "info" : "outline-info"}
                      size="sm"
                      className={activeStatusFilter === "delivered" ? "text-white" : ""}
                      onClick={() => { setActiveStatusFilter("delivered"); setCurrentPage(1); }}
                    >
                      <i className="fa fa-check-double me-1"></i>
                      Delivered ({deliveredCount})
                    </Button>
                    <Button
                      variant={activeStatusFilter === "sent" ? "secondary" : "outline-secondary"}
                      size="sm"
                      onClick={() => { setActiveStatusFilter("sent"); setCurrentPage(1); }}
                    >
                      <i className="fa fa-check me-1"></i>
                      Sent ({sentCount})
                    </Button>
                    {failedCount > 0 && (
                      <Button
                        variant={activeStatusFilter === "failed" ? "danger" : "outline-danger"}
                        size="sm"
                        onClick={() => { setActiveStatusFilter("failed"); setCurrentPage(1); }}
                      >
                        <i className="fa fa-exclamation-triangle me-1"></i>
                        Failed ({failedCount})
                      </Button>
                    )}
                  </div>

                  <div style={{ maxWidth: "320px", width: "100%" }}>
                    <Form.Control
                      type="text"
                      size="sm"
                      placeholder="Search name or phone number..."
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div> */}

                {/* Table */}
                {/* {loadingRecipients ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2 text-muted">Loading recipients data...</p>
                  </div>
                ) : filteredRecipients.length === 0 ? (
                  <div className="text-center py-5 text-muted">
                    <i className="fa fa-address-book-o fa-3x mb-3 text-secondary"></i>
                    <h6>No recipients found</h6>
                    <p className="small mb-0">
                      {searchQuery
                        ? `No contact matches "${searchQuery}"`
                        : activeStatusFilter !== "all"
                        ? `No recipients found with status "${activeStatusFilter}"`
                        : "No message history records found for this template."}
                    </p>
                  </div>
                ) : (
                  <>
                    <Table responsive hover className="align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "45px" }}>#</th>
                          <th>Recipient Name</th>
                          <th>WhatsApp Number</th>
                          <th>Delivery Status</th>
                          <th>Sent At</th>
                          <th>Read / Delivered At</th>
                          <th className="text-end" style={{ minWidth: "140px" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedRecipients.map((item, idx) => {
                          const initials = (item.name || "?")
                            .split(" ")
                            .map((n) => n[0])
                            .slice(0, 2)
                            .join("")
                            .toUpperCase();
                          return (
                            <tr key={item.id || idx}>
                              <td>{(currentPage - 1) * recordsPerPage + idx + 1}</td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div
                                    className="rounded-circle text-white d-flex align-items-center justify-content-center fw-bold me-2"
                                    style={{
                                      width: "35px",
                                      height: "35px",
                                      backgroundColor: getAvatarColor(item.name || ""),
                                      fontSize: "0.85rem",
                                      flexShrink: 0
                                    }}
                                  >
                                    {initials}
                                  </div>
                                  <div>
                                    <div className="fw-semibold text-dark">
                                      {item.name || "Unknown"}
                                    </div>
                                    {item.err_message && (
                                      <small className="text-danger d-block">
                                        {item.err_message}
                                      </small>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span className="font-monospace text-secondary">
                                  <i className="fa fa-whatsapp text-success me-1"></i>
                                  {item.whatsapp_number}
                                </span>
                              </td>
                              <td>
                                {item.delivery_status === "read" ? (
                                  <Badge bg="success" className="px-2 py-1">
                                    <i className="fa fa-check-double me-1"></i> Read
                                  </Badge>
                                ) : item.delivery_status === "delivered" ? (
                                  <Badge bg="info" className="text-white px-2 py-1">
                                    <i className="fa fa-check-double me-1"></i> Delivered
                                  </Badge>
                                ) : item.delivery_status === "failed" ? (
                                  <Badge bg="danger" className="px-2 py-1">
                                    <i className="fa fa-exclamation-circle me-1"></i> Failed
                                  </Badge>
                                ) : (
                                  <Badge bg="secondary" className="px-2 py-1">
                                    <i className="fa fa-check me-1"></i> Sent
                                  </Badge>
                                )}
                              </td>
                              <td>
                                <small className="text-muted">
                                  {item.createddate
                                    ? moment(item.createddate).format("DD/MM/YYYY, h:mm A")
                                    : "-"}
                                </small>
                              </td>
                              <td>
                                <small className="text-muted">
                                  {item.received_time
                                    ? moment(item.received_time).format("DD/MM/YYYY, h:mm A")
                                    : item.delivery_status === "read"
                                    ? "Read"
                                    : "-"}
                                </small>
                              </td>
                              <td className="text-end">
                                <Dropdown align="end" className="d-inline-block">
                                  <Dropdown.Toggle
                                    variant="outline-secondary"
                                    size="sm"
                                    id={`status-dropdown-${item.id}`}
                                  >
                                    Update Status
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <Dropdown.Item
                                      onClick={() => handleUpdateStatus(item.id, "read")}
                                    >
                                      <i className="fa fa-check-double text-success me-2"></i>
                                      Mark as Read
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => handleUpdateStatus(item.id, "delivered")}
                                    >
                                      <i className="fa fa-check-double text-info me-2"></i>
                                      Mark as Delivered
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => handleUpdateStatus(item.id, "sent")}
                                    >
                                      <i className="fa fa-check text-secondary me-2"></i>
                                      Mark as Sent
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table> */}

                    {/* Pagination */}
                    {/* {totalPages > 1 && (
                      <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                        <small className="text-muted">
                          Showing {(currentPage - 1) * recordsPerPage + 1} to{" "}
                          {Math.min(currentPage * recordsPerPage, filteredRecipients.length)} of{" "}
                          {filteredRecipients.length} entries
                        </small>
                        <div className="btn-group" role="group">
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                          >
                            Previous
                          </Button>
                          <span className="btn btn-outline-secondary btn-sm disabled">
                            {currentPage} / {totalPages}
                          </span>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                          >
                            Next
                          </Button>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row> */}
      </Container>
        :

        <div className="sk-cube-grid">
            <div className="sk-cube sk-cube1"></div>
            <div className="sk-cube sk-cube2"></div>
            <div className="sk-cube sk-cube3"></div>
            <div className="sk-cube sk-cube4"></div>
            <div className="sk-cube sk-cube5"></div>
            <div className="sk-cube sk-cube6"></div>
            <div className="sk-cube sk-cube7"></div>
            <div className="sk-cube sk-cube8"></div>
            <div className="sk-cube sk-cube9"></div>
        </div>}
      {templateDelete && (
                <Confirm
                    show={templateDelete}
                    onHide={() => setTemplateDelete(false)}
                    deleteTemplate={deleteTemplate}
                    title="Confirm Delete"
                    message="You are going to delete the record. Are you sure?"
                    table="template"
                />
            )}
    </>
  );

};

export default Templateview;


